<template>
    <Toast />
    <Loading id="screen-loading" class="hide" />
    <div v-if="isVisibleRouter()">
        <router-link to="/">Home</router-link> |
        <router-link to="/AppointmentCancel">AppointmentCancel</router-link>
    </div>

    <router-view />
</template>

<script>
    import Loading from "./components/SubComponents/Loading.vue"

    export default {
        components: {
            Loading
        },
        methods: {
            isVisibleRouter() {
                return window.location.hash == "#/#fc";
            }
        }
    }
</script>